module.exports = __webpack_public_path__ + "img/payError.d79fe591.png";